var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPreorderAllowed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4659 3.97114C19.4659 3.95417 19.4659 3.95417 19.4659 3.9372C19.4489 3.90326 19.4489 3.86932 19.4319 3.83537V3.8184C19.415 3.78446 19.381 3.75052 19.3641 3.73355L19.3471 3.71658C19.3301 3.69961 19.2962 3.68264 19.2792 3.66567L19.2622 3.6487H19.2453L19.2283 3.63173L12.0158 0.050912C11.88 -0.0169707 11.7103 -0.0169707 11.5576 0.050912L9.13074 1.25583L16.3772 4.97241L16.3942 4.98938C16.4112 4.98938 16.4112 5.00635 16.4281 5.00635C16.4451 5.02332 16.4451 5.04029 16.4621 5.05726C16.4621 5.07423 16.4621 5.07423 16.4621 5.0912V5.10818V9.04537C16.4621 9.11326 16.4281 9.16417 16.3772 9.19811L14.9177 9.96179C14.8329 10.0127 14.7311 9.97876 14.6802 9.89391C14.6632 9.87694 14.6632 9.843 14.6632 9.80905V5.95671L7.33185 2.17225L7.31488 2.15528L4.37895 3.61476L4.36198 3.63173H4.34501L4.32804 3.6487C4.31107 3.66567 4.27713 3.68264 4.26016 3.69961L4.24319 3.71658C4.20925 3.75052 4.19228 3.78446 4.15833 3.8184V3.83537C4.14136 3.86932 4.12439 3.90326 4.12439 3.9372C4.12439 3.95417 4.12439 3.95417 4.12439 3.97114C4.12439 4.00508 4.10742 4.02205 4.10742 4.05599V4.07296V11.9813C4.10742 12.168 4.20925 12.3547 4.39592 12.4395L11.5406 16.0034C11.6424 16.0543 11.7612 16.0712 11.88 16.0373L11.9139 16.0203C11.9479 16.0203 11.9648 16.0034 11.9988 15.9864L19.1944 12.4225C19.3641 12.3377 19.4829 12.168 19.4829 11.9643V4.07296V4.05599C19.4659 4.02205 19.4659 4.00508 19.4659 3.97114Z",
    fill: "#212121"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 6,
    fill: "#00BD04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50021 9L5.5 12.5002H9",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPreorderAllowed);
export default __webpack_public_path__ + "static/media/icon-preorder-allowed.88c5101e39b24c2d63e7d9d27362b6ff.svg";
export { ForwardRef as ReactComponent };